import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var BORDER_WIDTH = 1;
export function Table(_ref) {
  var {
    children,
    node
  } = _ref;
  var withFixedColumns = node.colSizes !== undefined;
  var width = typeof node.colSizes !== 'undefined' ? node.colSizes.reduce((total, columnWidth) => total + columnWidth, BORDER_WIDTH) : undefined;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('prezly-slate-table-container', {
      'prezly-slate-table-container--withFixedColumns': withFixedColumns
    }),
    style: {
      '--width': "".concat(width, "px")
    },
    children: /*#__PURE__*/_jsx("table", {
      className: classNames('prezly-slate-table', {
        'prezly-slate-table--withFixedColumns': withFixedColumns
      }),
      children: /*#__PURE__*/_jsx("tbody", {
        children: children
      })
    })
  });
}